import React from 'react';

import Tippy from '@tippyjs/react';

import { iaRa } from 'lib/helpers/utility';

const ProceduresCell = ({ data, node, procedureCodes }) => {
  const procedures = iaRa(data?.procedures);
  const finalProcedures =
    procedureCodes || procedures.map((procedure) => procedure.procedure_code).filter(Boolean);

  const [firstProcedure, ...restProcedures] = finalProcedures || [];

  if (!!node?.group) {
    return null;
  }
  return (
    <div className="flex h-full flex-row items-center justify-center">
      {firstProcedure && (
        <div className="flex max-h-[20px] items-center rounded-[4px] border border-solid border-neutral-200 bg-neutral-100 p-1 text-xs text-neutral-900">
          {firstProcedure}
        </div>
      )}
      {restProcedures.length > 0 && (
        <div className="ml-3">
          <Tippy
            className="custom-tooltip tippy-dark !rounded-md "
            content={
              <div className="flex-column p-2">
                {restProcedures?.map((procedure) => (
                  <div key={procedure} className="text-slate-50 m-1 rounded-md p-1">
                    {procedure}
                  </div>
                ))}
              </div>
            }
            allowHTML
            interactive
            appendTo={() => document.body}
            placement="right"
            offset={[0, 10]}>
            <div className="flex max-h-[20px] items-center rounded-[4px] border border-solid border-neutral-200 bg-neutral-100 p-1 text-xs text-neutral-900">
              +{restProcedures.length}
            </div>
          </Tippy>
        </div>
      )}
    </div>
  );
};

export default ProceduresCell;
